package team.platforma.chat_data.repository.draft

import kotlinx.coroutines.flow.Flow
import team.platforma.chat_data.database.draft.DraftTable
import team.platforma.chatdata.table.Draft

class DraftRepositoryImpl(
    private val draftTable: DraftTable
) : DraftRepository {
    override suspend fun insertDraft(aiModelId: Long, userID: Long, chatID: Long) {
        draftTable.insertDraft(
            Draft(
                draftID = 0,
                aiModelID = aiModelId,
                userID = userID,
                chatID = chatID,
                text = ""
            )
        )
    }

    override suspend fun updateDraftText(draftId: Long, text: String, chatId: Long) {
        draftTable.updateDraft(draftId = draftId, text = text, chatId = chatId)
    }

    override fun observeDraftList(aiModelID: Long?, userID: Long, chatID: Long): Flow<List<Draft>> = draftTable.observeDraftList(aiModelID, userID, chatID)

}